import * as React from 'react';
import { Route, RouteProps, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import { LoginState } from '../../login/loginStore';

type PrivateRouteProps = LoginState & RouteProps & {onEnter?: () => void};

const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({ component, ...rest }) => {
  const Component = component as React.ElementType;
    return (
        <Route
        {...rest}
        render={routeProps =>
          rest.isLoggedIn ? (
            <Component {...routeProps} />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: routeProps.location }
              }}
            />
          )
        }
      />
    );
}

export default connect((state: ApplicationState) => state.login)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/components/routes/PrivateRoute.tsx